import { ArrowUpRight, ExternalLink, RadioTower, Volume2, VolumeX } from 'lucide-react'
import type { StartupPreparationState } from '../app/startup-preparation'

const PREPARATION_LABEL: Record<StartupPreparationState, string> = {
  preparing: 'PREPARING NIGHT GRID',
  ready: 'GRID READY',
  failed: 'PREPARATION FAILED',
}

interface TitleScreenProps {
  muted: boolean
  preparation: StartupPreparationState
  onStart: () => void
  onMultiplayer: () => void
  onToggleMute: () => void
}

export function TitleScreen({ muted, preparation, onStart, onMultiplayer, onToggleMute }: TitleScreenProps) {
  return (
    <section className="title-screen" aria-labelledby="tride-title">
      <div className="title-rail" aria-hidden="true">
        PROTOCOL 03 — NIGHT GRID / SEOUL 02:17
      </div>
      <div className="title-copy">
        <p className="eyebrow">MIDNIGHT COMBAT RACING</p>
        <h1 id="tride-title">TRIDE</h1>
        <p className="title-promise">DRIFT FOR BOOST. FIGHT FOR THE LINE.</p>
        <div className="title-actions">
          <button className="primary-button" type="button" onClick={onStart}>
            <span>{preparation === 'failed' ? 'Retry preparation' : 'Enter the night'}</span>
            <ArrowUpRight className="title-action-icon" aria-hidden="true" strokeWidth={1.8} />
          </button>
          <button className="icon-button" type="button" onClick={onMultiplayer} aria-label="Online race">
            <RadioTower className="title-action-icon" aria-hidden="true" strokeWidth={1.8} />
            <span>ONLINE RACE</span>
          </button>
          <button
            className="icon-button"
            type="button"
            onClick={onToggleMute}
            aria-label={muted ? 'Enable audio' : 'Mute audio'}
          >
            {muted ? (
              <VolumeX className="title-action-icon" aria-hidden="true" strokeWidth={1.8} />
            ) : (
              <Volume2 className="title-action-icon" aria-hidden="true" strokeWidth={1.8} />
            )}
            <span>{muted ? 'AUDIO OFF' : 'AUDIO ON'}</span>
          </button>
        </div>
        <p className={`title-preparation title-preparation--${preparation}`} role="status" aria-live="polite">
          <span aria-hidden="true" />
          {PREPARATION_LABEL[preparation]}
        </p>
      </div>
      <section className="control-grid" aria-label="Race controls">
        <span>
          <kbd>WASD</kbd> DRIVE
        </span>
        <span>
          <kbd>SHIFT</kbd> DRIFT
        </span>
        <span>
          <kbd>SPACE</kbd> FIRE
        </span>
        <span>
          <kbd>E</kbd> BOOST
        </span>
      </section>
      <a className="attribution-link" href="/ATTRIBUTION.md" target="_blank" rel="noreferrer">
        <span>MODEL ATTRIBUTION</span>
        <ExternalLink className="title-action-icon" aria-hidden="true" strokeWidth={1.8} />
      </a>
    </section>
  )
}
